import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER, PATTERN_NUMERIC_ARRAY_6DOF } from "src/constant/common";

const EngineSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.engine_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.VACUUM_ISP}`)}
          name={`MCS.${FORM_NAME.MCS.VACUUM_ISP}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.VACUUM_ISP}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.VACUUM_ISP]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.VACUUM_ISP}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.VACUUM_ISP}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.VACUUM_ISP}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.THRUST_TIME_CONSTANT}`)}
          name={`MCS.${FORM_NAME.MCS.THRUST_TIME_CONSTANT}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_TIME_CONSTANT}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.THRUST_TIME_CONSTANT]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_TIME_CONSTANT}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_TIME_CONSTANT}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_TIME_CONSTANT}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.ENGINE_PITCH_LENGTH}`)}
          name={`MCS.${FORM_NAME.MCS.ENGINE_PITCH_LENGTH}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.ENGINE_PITCH_LENGTH}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.ENGINE_PITCH_LENGTH]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.ENGINE_PITCH_LENGTH}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.ENGINE_PITCH_LENGTH}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.ENGINE_PITCH_LENGTH}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.TVC2_POSITION}`)}
          name={`MCS.${FORM_NAME.MCS.TVC2_POSITION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.TVC2_POSITION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.TVC2_POSITION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.TVC2_POSITION}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.TVC2_POSITION}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.TVC2_POSITION}`) }),
          }}
          unit="x, y, z) (m"
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.MAX_THRUST_OF_ENGINE}`)}
          name={`MCS.${FORM_NAME.MCS.MAX_THRUST_OF_ENGINE}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_THRUST_OF_ENGINE}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.MAX_THRUST_OF_ENGINE]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_THRUST_OF_ENGINE}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_THRUST_OF_ENGINE}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.MAX_THRUST_OF_ENGINE}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.THRUST_DELAY_TIME}`)}
          name={`MCS.${FORM_NAME.MCS.THRUST_DELAY_TIME}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_DELAY_TIME}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.THRUST_DELAY_TIME]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_DELAY_TIME}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_DELAY_TIME}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_DELAY_TIME}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          type="number"
          label={t(`new.MCS.${FORM_NAME.MCS.TVC1_POSITION}`)}
          name={`MCS.${FORM_NAME.MCS.TVC1_POSITION}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.TVC1_POSITION}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.TVC1_POSITION]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.TVC1_POSITION}`) })}
          required
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.TVC1_POSITION}`) })}
          pattern={{
            value: PATTERN_NUMERIC_ARRAY_6DOF,
            message: t("new.wrong_format", { field: t(`new.MCS.${FORM_NAME.MCS.TVC1_POSITION}`) }),
          }}
          unit="x, y, z) (m"
        />
      </div>
    </div>
  );
};

export default EngineSigma;
